import Vue from 'vue';

export const Hour12 = Vue.filter('hour12', (hour: string) => {
  const [h, m] = hour.split(':');
  const hour12 = parseInt(h, 10) % 12;
  const amPm = parseInt(h, 10) < 12 ? 'AM' : 'PM';

  return `${hour12 === 0 ? 12 : hour12}:${m} ${amPm}`;
});